import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import "./UploadImage.css";
import Button from "../Button/Button";

const UploadImage = ({ onFileSelect, existingImages, multiple = false }) => {
  const [previews, setPreviews] = useState([]);


  useEffect(() => {
    if (existingImages) {

      const imagesArray = Array.isArray(existingImages) ? existingImages : [existingImages];
      setPreviews(imagesArray.filter(img => img));
    }
  }, [existingImages]);

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    multiple: multiple,
    noClick: true,
    noKeyboard: true,
    accept: { "image/*": [] },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length) {

        if (multiple) {
          onFileSelect(acceptedFiles);
        } else {
          onFileSelect(acceptedFiles[0]);
        }


        const newPreviews = acceptedFiles.map((file) => URL.createObjectURL(file));

        if (multiple) {
          setPreviews((prev) => [...prev, ...newPreviews]);
        } else {
          setPreviews(newPreviews);
        }
      }
    },
  });

  const removeImage = (index) => {
    const updated = previews.filter((_, i) => i !== index);
    setPreviews(updated);
  };

  return (
    <div
      {...getRootProps()}
      className={`upload-card container-fluid py-4 ${isDragActive ? "drag-active" : ""}`}
      style={{ border: "2px dashed #dbdbdb", borderRadius: "12px", background: "#fafafa" }}
    >
      <input {...getInputProps()} />

      <div className="d-flex flex-column justify-content-center align-items-center">

        {previews.length > 0 && (
          <div className="d-flex flex-wrap justify-content-center gap-3 mb-3">
            {previews.map((src, index) => (
              <div key={index} className="position-relative d-inline-block">
                <img
                  src={src}
                  alt={`preview-${index}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />

                <button
                  type="button"
                  className="remove-image-btn"
                  onClick={() => removeImage(index)}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        )}

        {!previews.length && (
          <div className="icon-stack mb-3">
            <i className="fas fa-cloud-upload-alt fa-3x text-primary"></i>
          </div>
        )}

        <p className="text-muted small">
          {isDragActive ? "Drop files here..." : "Drag & drop images or click to upload"}
        </p>

        <Button className="d-flex justify-content-center align-items-center" onClick={open}>
          {multiple ? "Add Images" : "Change Image"}
        </Button>
      </div>
    </div>
  );
};

export default UploadImage;